import { api } from '$lib/utils/api';
import { createMutation, createQuery } from '@tanstack/svelte-query';

export function useCreateTranscriptionMutation(options = {}) {
  return createMutation({
    mutationFn: (props) => {
      const { clientId, calendarEventId, transcription } = props;
      return api().post(`v2/transcription`, {
        clientId,
        calendarEventId,
        transcription,
      });
    },
    ...options,
  });
}

export function useGenerateSummarizationMutation(options = {}) {
  return createMutation({
    mutationFn: (props) => {
      const { transcriptionId } = props;
      return api().post(`v2/transcription/${transcriptionId}/runSummarization`);
    },
    ...options,
  });
}

export function useUpdateTranscriptionMutation(options = {}) {
  return createMutation({
    mutationFn: (props) => {
      const { transcriptionId, calendarEventId, transcription } = props;
      return api().put(`v2/transcription/${transcriptionId}`, {
        calendarEventId,
        transcription,
      });
    },
    ...options,
  });
}

export function useGetTranscriptionQuery(
  { clientId, calendarEventId },
  options = {},
) {
  return createQuery({
    queryKey: ['transcription', clientId, calendarEventId],
    queryFn: () => api().get(`v2/transcription/${clientId}/${calendarEventId}`),
    ...options,
  });
}

export function useGetTranscriptionByIdQuery(
  { transcriptionId },
  options = {},
) {
  return createQuery({
    queryKey: ['transcription', transcriptionId],
    queryFn: () => api().get(`v2/transcription/${transcriptionId}`),
    ...options,
  });
}
